import { render, staticRenderFns } from "./FleetTable.vue?vue&type=template&id=af34ef20&"
import script from "./FleetTable.vue?vue&type=script&lang=js&"
export * from "./FleetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports